<ng-container *ngIf="isVisible">
    <ng-container *ngIf="docState$ | async; let docState">
        <div class="mod mod-modal" [class.is-open]="isVisible">
            <div class="mod-modal__dialog mod-modal__dialog--small">
                <div
                    *ngIf="docState && docState.metadata"
                    class="mod-modal__content"
                >
                    <div
                        class="zas-esign-row"
                        style="background: white; height: 20px; color: black"
                    >
                        <div class="zas-esign-signed-indicator">Signiert</div>

                        <div class="zas-esign-label">Titel</div>

                        <div class="zas-esign-page-number">Seite</div>
                    </div>

                    <div *ngFor="let field of docState?.signatures">
                        <div style="height: 10px"></div>
                        <div
                            class="zas-esign-row"
                            (click)="requestSignature(field)"
                        >
                            <div class="zas-esign-signed-indicator">
                                <span
                                    [class.icon-hook]="
                                        esignService.isSigned(field)
                                    "
                                    [class.icon-accordeon-minus]="
                                        !esignService.isSigned(field)
                                    "
                                ></span>
                            </div>

                            <div class="zas-esign-label">
                                {{ field.metadata.Label }}
                            </div>

                            <div class="zas-esign-page-number">
                                {{ field.metadata.Page }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mod-modal__footer">
                    <button class="zas-button" (click)="close()">
                        Schließen
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
